import Button, { ButtonType } from 'inquiry/components/Button';
import { useApply } from 'inquiry/lib/jsonLogic';
import { ButtonLinkComponent } from 'lib/interfaces/ui-components';
import { Inquiry } from 'verify/models/inquiry';

interface ButtonLinkProps {
  component: ButtonLinkComponent;
  inquiry: Inquiry;
}

const ButtonLink = ({ component, inquiry }: ButtonLinkProps) => {
  const { 'button-type': buttonType, hidden, text, link } = component.attributes;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden);

  if (isHidden) {
    return null;
  }

  return (
    <Button
      href={link}
      id={component.name}
      type='button'
      buttonType={buttonType ?? ButtonType.Primary}
      styles={component?.styles}
    >
      {text}
    </Button>
  );
};

export default ButtonLink;
